export const environment = {
  env:'Environment Dev',
  copyRight:'zorozo.com',
  production:true,
  //api_base:'http://localhost:9000/api'
  api_base:'https://t7fsspjzmd.execute-api.us-east-1.amazonaws.com/dev/api',
  google:{"client_id":"330227382245-tjt54ubpchjg6njve2imetfprt6qep93.apps.googleusercontent.com"}
};

